const customModalHomeAdminForm = {
  'custom-home-modal-admin-form-message-label': 'Startseitenbild',
  'custom-home-modal-admin-title': 'Benutzerdefiniertes Startseiten-Modal',
  'custom-home-modal-admin-description': 'Verwalte das Bild und die Sichtbarkeit des Startseiten-Modals.',
  'custom-home-modal-admin-form-status-label-deactivated': 'Aktivieren',
  'custom-home-modal-admin-form-status-label-activated': 'Deaktivieren',
  'custom-home-modal-admin-error-required': 'Dieses Feld ist erforderlich.',
  'custom-home-modal-admin-subbmiting-message': 'Modal-Konfiguration wird gespeichert...',
  'custom-home-modal-admin-img-loader-info': 'Lade ein Bild hoch, das im Startseiten-Modal angezeigt wird.',
  'custom-home-modal-admin-getting-details': 'Startseitenbild wird abgerufen...',
  'custom-home-modal-admin-image-setting-successfull': 'Das Bild der Startseite wurde erfolgreich festgelegt',
  'custom-home-modal-admin-boton-change-img': 'Bild ändern',
  'custom-home-modal-admin-boton-accept': 'Akzeptieren',
  'custom-home-modal-admin-boton-show-modal': 'Startbanner anzeigen',
  'custom-home-modal-admin-img-not-found': 'Bild nicht gefunden oder noch nicht festgelegt'
};

export default customModalHomeAdminForm;
